<!--
 * 侧边栏导航
 * @author 滕威
 * @time 2021-01-08
 *
-->
<!-- 模板(html)代码 start -->
<template>
  <div class="layout-aside">
    <!-- <img class="asideMenu" src="@/assets/images/asideMenu.png"> -->
    <el-menu
      ref="menu"
      router
      :default-active="routerPath"
      class="el-menu-vertical-demo"
      @select="fun_HandleSelect"
      text-color="rgba(255,255,255,.7)"
      active-text-color="#FFFFFF"
    >
      <!-- 一级菜单 -->
      <div v-for="(item, index) in asyncRouters" :key="index">
        <el-submenu
          class="menuOne"
          v-if="item.children && item.children.length > 0"
          :index="item.id"
        >
          <div slot="title">
            <i :class="'el-icon-' + item.icon"></i>
            <span slot="title" :title="item.title">{{ item.title }}</span>
          </div>
          <!-- 二级菜单 -->
          <template v-for="itemChild in item.children">
            <el-submenu
              class="menuTwo"
              v-if="itemChild.children && itemChild.children.length"
              :index="itemChild.path"
              :key="itemChild.path"
            >
              <div slot="title">
                <i :class="'el-icon-' + itemChild.icon"></i>
                <span slot="title" :title="itemChild.title">{{ itemChild.title }}</span>
              </div>
              <!-- 三级菜单 -->
              <template v-for="itemChild_Child in itemChild.children">
                <el-menu-item
                  class
                  :index="itemChild_Child.path"
                  :key="itemChild_Child.path"
                >
                  <div slot="title">
                    <span :title="itemChild_Child.title">{{ itemChild_Child.title }}</span>
                  </div>
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item v-else :index="itemChild.path" :key="itemChild.path">
              <i :class="'el-icon-' + itemChild.icon" v-if="itemChild.icon"></i>
              <span slot="title" :title="itemChild.title">{{ itemChild.title }}</span>
            </el-menu-item>
          </template>
        </el-submenu>
        <el-menu-item v-else :index="item.path" :key="item.path">
          <i :class="'el-icon-' + item.icon"></i>
          <span slot="title" :title="item.title">{{ item.title }}</span></el-menu-item
        >
      </div>
    </el-menu>
  </div>
</template>
<!-- 模板(html)代码 end -->

<!-- JS代码 start -->
<script>
import { mapState } from "vuex";
/*
 * VUE组件默认导出属性
 * @author 滕威
 */
export default {
  /**
   * 组件默认导出属性
   * @author 滕威
   */
  // 初始化数据对象
  data() {
    return {
      activePath: "", // 选中的菜单
    };
  },
  // 计算属性
  computed: {
    ...mapState(["asyncRouters"]),
    // 默认选中路由
    routerPath() {
      // 删除存储
      this.resetSetItem("flag", "");
      let path = null;
      // 进入详情页面时，侧边栏依然高亮
      if (this.$route.path.indexOf("Detail") > -1) {
        path = this.$route.path.replace("Detail", "");
      } else if (
        this.$route.path === "/expertSelectManagerSelect" ||
        this.$route.path === "/expertSelectManagerExpertInfo" ||
        this.$route.path === "/expertSelectManagerIsLongRangePlace"
      ) {
        path = "/expertSelectManager";
      } else {
        path = this.$route.path;
      }
      return path;
    },
  },
  watch: {
    // 监听路由对象中的'$route.query'属性
    '$route.query':'getPath'
  },

  // 模板编译完成
  mounted() {
    // 页面初始化
    this.fun_Init();
  },

  // 自定义事件
  methods: {
    /**
     * 监听路由传参
     * @param to 当前传递的参数
     * @param from 上一个传递的参数
     */
    getPath(to, from){
      // 判断是切换角色
      if ((to.type === "招标人" || to.type === "投标人" || to.type === "招标代理") && this.$route.path === "/home"){
        // 菜单全部关闭
        this.$refs.menu.openedMenus = [];
      }
    },
    /**
     * 页面初始化
     * @author 滕威
     */
    fun_Init() {
      // 获取选中path
      this.activePath = this.$route.path;
    },
    /**
     * 选择菜单执行
     * @params key 选中菜单path
     * @author 滕威
     */
    fun_HandleSelect(key) {
      // 将选中的菜单path赋值
      this.activePath = key;
    }
  }
};
</script>
<!-- JS代码 end -->

<!-- css样式 start-->
<style lang="scss" scoped>
.layout-aside {
  height: 100%;
  .asideMenu{
    position: absolute;
    bottom: 0;
    left: 0;
    pointer-events: none;
    z-index: 1;
  }
  .el-submenu {
    /deep/.el-submenu__title {
      color: #252C37 !important;
      &:hover{
        color: #252C37 !important;
      }
    }
    &.is-opened {
      /deep/.el-submenu__title {
        color: #252C37 !important;
        &:hover{
          color: #252C37 !important;
        }
        > div:first-of-type {
          > i {
            color: #0E70B5;
          }
          > span {
            color: #0E70B5;
          }
        }
        > i {
          color: #0E70B5 !important;
        }
      }
    }
    /deep/.el-submenu__title {
      height: 60px;
      line-height: 60px;
      text-align: left;
      padding: 0 20px 0 14px !important;
      background-color: #F1F6F9 !important;
      color: #303946 !important;
      > div:first-of-type {
        > span{
          font-size: 18px;
          font-weight: bold;
        }
        > i {
          color: #303946;
          font-size: 23px;
          margin-right: 10px;
        }
      }
      > i {
        color: #3D3D3E;
        font-size: 23px;
        margin-top: -11px;
      }
    }
  }
  .el-menu {
    border-right: none;
  }
  .el-menu-item {
    height: 50px;
    line-height: 50px;
    padding: 0px 16px 0 39px !important;
    background-color: #F1F6F9 !important;
    color: #181818 !important;
    text-align: left;
    text-indent: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    span{
      font-size: 16px;
      font-weight: bold;
    }
  }
  .el-menu-item:hover {
    color: #FFFFFF !important;
    background-color: #0E70B5 !important;
  }
  /deep/.el-submenu .is-active {
    color: #FFFFFF !important;
    background-color: #0E70B5 !important;
  }
  /deep/.el-submenu {
    .el-menu {
      background-color: #F1F6F9 !important;
      span{
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
</style>
<!-- css样式 end-->
